// MC CATFER-117 Archivo de constantes para notificaciones

export const CANAL_EMAIL = 2;
export const CANAL_SOCKET = 3;

export const  TIPO_RECEPTOR_EMPLEADO = 2;
export const  TIPO_RECEPTOR_CLIENTE = 3;
export const  TIPO_RECEPTOR_PROVEEDOR = 4;
export const  TIPO_RECEPTOR_USUARIO_WEB = 5;
export const  TIPO_RECEPTOR_USUARIO_SINERGIAL = 6;
export const  TIPO_RECEPTOR_CLIENTE_VENTA = 7;
export const  TIPO_RECEPTOR_PROVEEDOR_COMPRA = 8;
export const  TIPO_RECEPTOR_USUARIO_MELI = 9;
export const  TIPO_RECEPTOR_PEDIDO_VENTA_MELI = 10;

export const TIPO_NOTIF_EMISION_FACT_ELECTR = 4;
export const TIPO_NOTIF_EMISION_REMITO_DEV = 5;
export const TIPO_NOTIF_EMISION_PRESUPUESTO = 6;
export const TIPO_NOTIF_EMISION_RECIBO = 7;